<script setup lang="ts">
import { Cookie } from '~/utils/cookie';

const cookie = useCookie<Cookie>('_moodeng')
const lang = useState<string>('language')
const updateCookie = () => {
    cookie.value = (cookie.value || new Cookie())
    cookie.value.language = useState('language') as unknown as string
    // only one in page or it broke _Orz_ 
    // updateCookie() affect only the first element
}
</script>

<template>
    <div>
        <label for="lang-select">Language:&nbsp;</label>
        <select id="lang-select" v-model="lang" @change="updateCookie()">
            <option value="en">English</option>
            <option value="th">ภาษาไทย</option>
        </select>
    </div>
</template>